import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface FetchVatReturnsReceivedListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  originatingCountry?: string;
  schemeType?: string;
}

export interface VatReturnsReceivedListElement {
  applicant_id: number;
  vat_number: string;
  is_sent: boolean;
  type: string;
  reminded_date: Date;
}

export interface VatReturnsReceivedListData {
  paging: VatReturnsReceivedListPaging;
  items: VatReturnsReceivedListElement[];
}

export interface VatReturnsReceivedListPaging {
  page: number;
  pageSize: number;
  total: number;
}

export const fetchVatReturnsReceivedList = async (
  payload: FetchVatReturnsReceivedListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.originatingCountry)
    searchQuery += `&originatingCountry=${payload.originatingCountry}`;
  if (payload.schemeType) searchQuery += `&schemeType=${payload.schemeType}`;
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vat-return-received/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: VatReturnsReceivedListData = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface FetchPaymentReceivedDetailListInput {
  vatReferenceNumber: string;
  vatVersion: string;
}

export const fetchPaymentReceivedDetailList = async (
  payload: FetchPaymentReceivedDetailListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  // if (payload.vatReferenceNumber) {
  //   searchQuery += `&vatReferenceNumber=${payload.vatReferenceNumber}`;
  // }
  // if (payload.vatVersion) {
  //   searchQuery += `&vatVersion=${payload.vatVersion}`;
  // }
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/payment-received/details?vatReferenceNumber=${payload.vatReferenceNumber}&vatVersion=${payload.vatVersion}`
  );

  let _data: VatReturnsReceivedListData = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
